export const NEAR_SCHEDULE_THRESHOLD_MINUTES = 90;

const MILLISECONDS_PER_MINUTE = 60 * 1000;

export function isScheduleNear(start: string, now: Date = new Date()): boolean {
  const startTime = new Date(start).getTime();

  if (Number.isNaN(startTime)) {
    return false;
  }

  return startTime - now.getTime() < NEAR_SCHEDULE_THRESHOLD_MINUTES * MILLISECONDS_PER_MINUTE;
}
